import { generatePath } from 'react-router-dom';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response } from '@ui/src';
import { applicationShemesApi } from '../services/application-shemes';
import { ApplicationScheme } from '../../applications/types';

import ROUTES from '../../../../routes';

export interface ApplicationSchemesState {
  applicationSchemas?: ApplicationScheme[];
  applicationSchemasForSelect?: ApplicationScheme[];
  scheme?: ApplicationScheme;
}

const initialState: ApplicationSchemesState = {};

export const applicationSchemesSlice = createSlice({
  name: 'applicationSchemes',
  initialState,
  reducers: {
    setApplicationSchemasForSelect: (
      state,
      action: PayloadAction<ApplicationScheme[]>,
    ) => {
      state.applicationSchemasForSelect = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      applicationShemesApi.endpoints.getEmployeesApplicationSchemes
        .matchFulfilled,
      (state, action: PayloadAction<Response<ApplicationScheme>>) => {
        state.applicationSchemas = action.payload.data.edges.map((item) => ({
          ...item.node,
          url: generatePath(ROUTES.APPLICATION_ITEM, {
            schemeId: item.node.id,
          }),
        }));
      },
    );
    builder.addMatcher(
      applicationShemesApi.endpoints.getApplicationScheme.matchFulfilled,
      (state, action: PayloadAction<{ data: ApplicationScheme }>) => {
        state.scheme = action.payload.data;
      },
    );
    builder.addMatcher(
      applicationShemesApi.endpoints.editApplicationSchemeActive.matchFulfilled,
      (state, action: PayloadAction<{ data: ApplicationScheme }>) => {
        state.scheme = action.payload.data;

        if (state.applicationSchemas) {
          state.applicationSchemas = state.applicationSchemas?.map((item) => {
            let result = { ...item };

            if (result.id === action.payload.data.id) {
              result = action.payload.data;
            }

            return result;
          });
        }
      },
    );
    builder.addMatcher(
      applicationShemesApi.endpoints.editApplicationSchemeVisibility
        .matchFulfilled,
      (state, action: PayloadAction<{ data: ApplicationScheme }>) => {
        state.scheme = action.payload.data;

        if (state.applicationSchemas) {
          state.applicationSchemas = state.applicationSchemas?.map((item) => {
            let result = { ...item };

            if (result.id === action.payload.data.id) {
              result = action.payload.data;
            }

            return result;
          });
        }
      },
    );
  },
});

export const { setApplicationSchemasForSelect } =
  applicationSchemesSlice.actions;

export default applicationSchemesSlice.reducer;
